import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconCheckCircle } from '#src/atoms/icons/system/iconCheckCircle.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BodyS } from '#src/atoms/typography/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

type Props = {
  status: 'owned' | 'equipped';
};

export const ClubShopItemStatus = ({ status }: Props) => (
  <BodyS
    bold
    color={
      status === 'equipped' ? 'var(--c-onBase-success)' : 'var(--c-nd-800)'
    }
    as="div"
  >
    <Horizontal gap={0.5}>
      <FontAwesomeIcon icon={iconCheckCircle} />
      <FormattedMessage
        {...(status === 'equipped' ? glossary.equipped : glossary.owned)}
      />
    </Horizontal>
  </BodyS>
);
